export enum CompaniesRoutingEnum {
  View = ':companyId',
  Register = 'inscription',
  SecureSpace = 'espace-securise',
  RegisterConfirmation = 'inscription-confirmation',
}

export enum SecureSpaceTabsEnum {
  engagement = 'engagement',
  companyPage = 'page-entreprise',
  mykit = 'kit-communication',
  jobOffers = 'offre-emploi',
}
